export default __webpack_public_path__ + "img/allergy-crustaceans.e4d8a8a31df841e7ddc06467b3593695.svg";